import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic would go here
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <div className="section-header">
          <h2 className="section-title">Get In Touch</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">We're Here to Help You Succeed</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="info-card">
              <div className="info-icon">📍</div>
              <h3>Our Locations</h3>
              <div style={{ marginBottom: '15px' }}>
                <p><strong>Uzice Office</strong></p>
                <p>Gostinica BB</p>
                <p>Uzice, 31204</p>
                <p>Serbia</p>
              </div>
              <div>
                <p><strong>Belgrade Office</strong></p>
                <p>Dusice Spasic 48a</p>
                <p>Rakovica Beograd, Belgrade 11090</p>
                <p>Serbia</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">📞</div>
              <h3>Phone Number</h3>
              <p>+381 631983203</p>
            </div>

            <div className="info-card">
              <div className="info-icon">👤</div>
              <h3>Contact Person</h3>
              <p><strong>Nikola Baovic</strong></p>
              <p>Contact Manager</p>
            </div>

            <div className="info-card">
              <div className="info-icon">🕐</div>
              <h3>Business Hours</h3>
              <p>Monday - Friday</p>
              <p>9:00 AM - 5:00 PM</p>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <h3>Send Us a Message</h3>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Your Message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <button type="submit" className="btn btn-primary">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;

